import { usePermissions } from 'lib/rbac'

export type RoleManagementCapabilities = {
  isAdmin: boolean
  canInvite: boolean
  canAssignRoles: boolean
  //The only roles available to silently assign when inviting a user
  enforcedRoles: string[] | null
  // Filter the roles before submitting to the API based on which role can the current user assing to invitees
  getSubmissionRoles: (selectedRoles: string[]) => string[]
  defaultInviteRoles: string[]
}

export const useRoleManagementCapabilities = (): RoleManagementCapabilities => {
  const { isAdmin, can } = usePermissions()

  const canInvite = can('org.settings:invite')

  if (isAdmin) {
    return {
      isAdmin,
      canInvite,
      canAssignRoles: true,
      enforcedRoles: null,
      getSubmissionRoles: (selectedRoles: string[]) => selectedRoles,
      defaultInviteRoles: []
    }
  }

  return {
    isAdmin,
    canInvite,
    canAssignRoles: false,
    enforcedRoles: [],
    getSubmissionRoles: () => [],
    defaultInviteRoles: []
  }
}
